import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import '../../css/BuilderLayout.scss';
import { useDroppable } from '@dnd-kit/core';
import ItemBankCard from './ItemBankCard';
import itemBankService from '../services/ItemBankService';
import Loader from '../../lessonPlayer/components/Loader';
import AddItemToAssessmentButton from './AddItemToAssessmentButton';

const Droppable = (props) => {
  const { id, data, children, className } = props;
  const { isOver, setNodeRef } = useDroppable({
    id,
    data
  });

  const style = {
    backgroundColor: isOver ? '#d2e9f7' : '',
  };

  return (
    <div 
      ref={setNodeRef} 
      className={className} 
      style={style}
      role="region"
      aria-label={`Resource bank drop zone ${id}`}>
      {children}
    </div>
  );
};

const ResourceBucketItemList = observer((props) => {
  const {
    itemBankManager,
    lessonManager
  } = useContext(MobXProviderContext);
  const { Draggable, dragging, refreshCallback } = props;

  useEffect(() => {
    async function getResourceBankItems() {
      if (lessonManager.lessonContentItem && lessonManager.lessonContentItem.id) {
        await itemBankService.fetchLessonBankItems(lessonManager.lessonContentItem.id);
        if (itemBankManager.lessonItems.size === 0 && itemBankManager.resourceBucketItems.size === 0) {
          itemBankManager.setViewMode('addItems');
        }
      }
    }
    getResourceBankItems().then();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonManager.lessonContentItem]);

  const items = itemBankManager.resourceBucketItemsArray;

  return (
    <Droppable
      key='bucket_list_Droppable'
      className='resource-bank-items'
      direction='horizontal'
      id='bucket_list_Droppable'>
      <div className='resource-bank-item-list'>
        {
          (items && items.length > 0) &&
            items.map((item, idx) => {
              const { libraryResource } = item;
              if (item.visibleInResourceBucket && libraryResource.showInStore) {
                return (
                  <div key={`${item.id}_ibCR-${idx}`} className='item-bank-card-controller resource-list'>
                    {(!dragging || !dragging.isDragging || dragging.item.id !== item.id) ? (
                      <>
                        <Draggable key={`${item.id}_drg`} data={item} disabled={false} id={item.id}
                          index={idx}>
                          <div className='item-draggable-container'>
                            <ItemBankCard className='item-drop-target' includeRemove={true} libraryCardParams={item} refreshCallback={refreshCallback} />
                          </div>
                        </Draggable>
                        <AddItemToAssessmentButton itemId={item.id} refreshCallback={refreshCallback} />
                      </>
                    ) : null}
                  </div>
                );
              }
              return (<React.Fragment key={`${item.id}_ibCR-${idx}`} />);
            })
        }
        {
          itemBankManager.loading && <Loader />
        }
      </div>
    </Droppable>
  );
});

export default ResourceBucketItemList;
